export const ACOMODACOES = [
  { value: 'REDE', label: 'Rede', icon: 'fa-bed' },
  { value: 'BARRACA', label: 'Barraca', icon: 'fa-campground' },
  { value: 'ALOJAMENTO', label: 'Alojamento', icon: 'fa-house', femininoOnly: true }
]

export function acomodacaoLabel(value) {
  return ACOMODACOES.find(a => a.value === value)?.label || null
}

export function acomodacoesDisponiveis(sexo) {
  if (sexo === 'F') return ACOMODACOES
  return ACOMODACOES.filter(a => !a.femininoOnly)
}
